import React from "react"
import { Navigate } from "react-router-dom"

import AppLayout from "Layout"
import { FEATURES_TYPE, REPORT_ROUTES } from '@constants'
import { CommonReports, ExtraReports, RatingReports } from "./Reports"
import { ConditionsPage, NotificationsPage } from './Alerts'
import GroupingExportsPage from './ExportsGrouping'
import { userData } from '../../@signals'


export const reportRoutes = userData => ({
	id: FEATURES_TYPE.COMMON,
	path: REPORT_ROUTES.PATH,
	title: 'Reports',
	icon: 'files',
	element: <AppLayout/>,
	children: [{
		element: <Navigate to={REPORT_ROUTES.COMMON_PATH} replace/>, index: true
	}, {
		path: REPORT_ROUTES.COMMON_PATH,
		title: REPORT_ROUTES.MAIN_TITLE,
		element: <CommonReports/>
	}, {
		path: REPORT_ROUTES.RATING_PATH,
		title: REPORT_ROUTES.RATING_TITLE,
		element: <RatingReports/>,
	}, ...userData?.features?.includes('reports-extras') ? [{
		path: REPORT_ROUTES.EXTRA_PATH,
		title: REPORT_ROUTES.EXTRA_TITLE,
		element: <ExtraReports/>,
	}] : [], ...userData?.features?.includes('reportGroups') ? [{
		path: REPORT_ROUTES.GROUPING_PATH,
		title: REPORT_ROUTES.GROUPING_TITLE,
		subtitle: REPORT_ROUTES.GROUPING_TITLE,
		element: <GroupingExportsPage/>,
	}] : [], {
		path: REPORT_ROUTES.CONDITIONS_PATH,
		title: REPORT_ROUTES.CONDITIONS_TITLE,
		element: <ConditionsPage/>,
	}, {
		path: REPORT_ROUTES.NOTIFICATION_PATH,
		title: REPORT_ROUTES.NOTIFICATION_TITLE,
		element: <NotificationsPage/>,
	}]
})